import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

type HistoryError = FetchBaseQueryError | SerializedError | undefined;

const FALLBACK_MESSAGES: Record<number, string> = {
  400: "Invalid request. Please check the selected period and try again.",
  401: "Authorization required. Please sign in again.",
  503: "Service is temporarily unavailable. Please try again later.",
};

const DEFAULT_MESSAGE = "Failed to load history. Please try again later.";

const extractBackendMessage = (data: unknown): string | null => {
  if (!data || typeof data !== "object") return null;

  const { message, detail } = data as Record<string, unknown>;
  if (typeof message === "string") return message;
  if (typeof detail === "string") return detail;
  return null;
};

export const getHistoryErrorMessage = (error: HistoryError): string | null => {
  if (!error) return null;

  if (!("status" in error)) {
    return error.message ?? DEFAULT_MESSAGE;
  }

  const fallback =
    typeof error.status === "number" ? FALLBACK_MESSAGES[error.status] : null;

  return extractBackendMessage(error.data) ?? fallback ?? DEFAULT_MESSAGE;
};
